import {
  GET_TASK_DASHBOARD_STATS,
  GET_TASK_DASHBOARD_STATS_SUCCESS,
  GET_TASK_DASHBOARD_STATS_ERROR,
} from './actionTypes';

export const getTaskDashboardStats = (user) => {
  return {
    type: GET_TASK_DASHBOARD_STATS,
    payload: { user },
  };
};

export const getTaskDashboardStatsSuccess = (stats, message) => {
  return {
    type: GET_TASK_DASHBOARD_STATS_SUCCESS,
    payload: { stats, message },
  };
};

export const getTaskDashboardStatsError = (msg) => {
  return {
    type: GET_TASK_DASHBOARD_STATS_ERROR,
    payload: msg,
  };
};
